import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Role → their dashboard URL (used for wrong-role redirects)
const ROLE_DASHBOARDS = {
    admin: '/admin-dashboard',
    doctor: '/doctor-dashboard',
    pharmacy: '/pharmacy-dashboard',
    lab: '/lab-dashboard',
    patient: '/patient-dashboard',
    reception: '/reception-dashboard',
};

/**
 * PrivateRoute
 * - If not logged in → redirect to /
 * - If logged in with wrong role → redirect to their own dashboard
 * - If logged in with correct role → render children
 */
function PrivateRoute({ children, allowedRoles }) {
    const { currentUser, userRole } = useAuth();
    const location = useLocation();

    if (!currentUser) {
        // Not authenticated — send to home (portal selection)
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    if (allowedRoles && !allowedRoles.includes(userRole)) {
        // Authenticated but wrong role — redirect to their own dashboard
        const correctPath = ROLE_DASHBOARDS[userRole] || '/';
        return <Navigate to={correctPath} replace />;
    }

    return children;
}

export default PrivateRoute;
